// A11yMixin: Adds accessible and semantic attributes to form fields dynamically.
export const A11yMixin = {
  mounted () {
    const view = this.$el
    const headline = view.querySelector('h4')
    const form = view.querySelector('form')
    const name = this.$options.name

    // Set a unique ID for the headline using the component's name
    headline.setAttribute('id', name + '-title')

    // Associate the container (view) with its headline
    view.setAttribute('aria-labelledby', name + '-title')

    if (form) {
      // Ensure the form allows browser autocomplete functionality
      form.setAttribute('autocomplete', 'on')

      // ARIA: Specify the element ID that will contain error messages
      form.setAttribute('aria-errormessage', 'errorMessage')

      // Iterate over all form controls (input and select) inside the form
      form
        .querySelectorAll('input, select')
        .forEach(field => this.setValidationAndAutocompleteFor(field))

      // Set a focus for the first form element
      if (form[0]) {
        this.$nextTick(() => {
          form[0].setAttribute('autofocus', true)
          form[0].focus()
        })
      }
    }
  },
  methods: {
    /**
     * Sets appropriate autocomplete values and validation handling for each field.
     * @param {HTMLElement} field - The input or select element to configure.
     */
    setValidationAndAutocompleteFor (field) {
      let fieldName = field.name

      // Special handling: If the field is a password and specifies a type in data attributes
      if (fieldName === 'password' && field.dataset.type) {
        fieldName = field.dataset.type + '-' + fieldName
      }

      // Apply proper autocomplete attribute based on the field's name/type
      field.setAttribute('autocomplete', this.getAutocompleteType(fieldName))

      // Revalidate the field on change to provide instant user feedback
      field.addEventListener('change', (e) => e.target.reportValidity())
    },

    /**
     * Returns the appropriate autocomplete value for a given field name.
     * @param {string} type - The field's name or generated type.
     * @returns {string} The matching autocomplete attribute value.
     */
    getAutocompleteType (type) {
      if (type === 'first_name') return 'given-name'
      else if (type === 'last_name') return 'family-name'
      else if (type === 'city') return 'address-level2'
      else if (type === 'email') return 'email'
      else if (type === 'phone') return 'tel'
      else if (type === 'address') return 'street-address'
      else if (type === 'zip') return 'postal-code'
      else if (type === 'birthday') return 'bday'
      else if (type === 'country') return 'country-name'
      else if (type === 'gender') return 'sex'
      else if (type === 'password') return 'current-password'
      else if (type === 'new-password') return 'new-password'
      else if (type === 'code') return 'one-time-code'
      else return 'on'
    }
  }
}
